import React from 'react';
import { connect } from 'react-redux';
import styles from './PatientSpecificTabs.module.css'
import { PatientSpecificTab } from 'PatientCareCenter';


class PatientSpecificTabs extends React.Component {

    render() {
        var tabCount = Object.keys(this.props.patientTabs).length;
        return (
            <div style={{ width: '100%' }}>
                <span className={styles.tab_container + ' ' + (tabCount > 7 ? styles.tab_container_wide : '')} >
                    {Object.keys(this.props.patientTabs)
                        .sort((a, b) => {
                            if (this.props.patientTabs[a].type === 'HOME')
                                return -1;
                            else if (this.props.patientTabs[a].type === 'IN' && !this.props.patientTabs[b].type === 'HOME')
                                return -1;
                            else
                                return 1;
                        })
                        .map(id => {
                            const result = this.props.patientTabs[id];
                            return <PatientSpecificTab key={result.id} id={result.id} selected={result.id === this.props.selectedPatientTab ? true : false} type={result.type} />
                        })
                    }
                    {tabCount <= 7 && <span className={styles.tab_white_space} />}

                </span>
            </div>
        );
    }
}

function mapStateToProps(state) {
    let patientTabs = Object.keys(state.ui.patientTabs)
        .filter(key => { return state.ui.patientTabs[key].ptno === state.ui.patients.selectedPtno })
        .map(key => state.ui.patientTabs[key]);

    let selectedPatientTab = state.ui.patientCenter[state.ui.patients.selectedPtno] ? state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab : '';

    return {
        patientTabs,
        selectedPatientTab,
    };
}

const connectedPatientSpecificTabs = connect(mapStateToProps)(PatientSpecificTabs);
export { connectedPatientSpecificTabs as PatientSpecificTabs };

